import { all, takeLatest, select, fork, put } from "redux-saga/effects";
// import { get } from "lodash";
import * as TYPES from "./clinicTypes";
// import history from "~/history";
import { client } from "~/utils/medproSDK";
import { openToast } from "~/components/common/molecules/ToastNotification";
import { CLINIC_TYPES } from "~/utils/constants";

function* onCreateClinic({ payload }) {
  const clinicType = payload.clinicType;
  try {
    const clinic = yield select(state => state.clinic);

    const formClinic =
      clinicType === CLINIC_TYPES.PK
        ? clinic.formPhongKham
        : clinic.formPhongMach;

    const keys = Object.keys(formClinic);

    const postData = {};

    keys.map(key => {
      postData[key] = formClinic[key].value;
      return "";
    });

    const response = yield client.registerClinic({ ...postData, clinicType });
    // thành công
    if (response.data.result === "success") {
      yield put({
        type: TYPES.CLINIC_FORM_SUCCESS,
        message: response.data.message
      });
    }
  } catch (error) {
    // yield put({
    //   type: TYPES.CLINIC_FORM_CREATE_FIELD_REQUEST_FAIL,
    //   error
    // });
    if (error.response.data.statusCode === 400) {
      openToast(error.response.data.message, "error");
    }
  }
}

function* watchOnCreateClinic() {
  yield takeLatest(TYPES.CLINIC_FORM_CREATE_FIELD_REQUEST, onCreateClinic);
}

export default function* root() {
  yield all([fork(watchOnCreateClinic)]);
}
